<template>
      <v-container v-if="questionnaire" class="app-page-container active-questionaire">
        <v-card class="shadow-none app-page-card">
              <v-card-title>
                {{questionnaire.title}}
                <v-spacer></v-spacer>
                  <span v-if="questionnaire.course.length > 0">
                    (course: {{questionnaire.course}})
                  </span>
                  <v-spacer></v-spacer>
                  <small> {{questionnaire.created_at}} ({{questionnaire.q_status}})</small>                
              </v-card-title>                            
              <v-card-text>
                <v-card class="shadow-none">
                  <v-pagination v-if="pages > 1"                  
                    v-model="page"
                    class="my-4 leaderboard__pagination"
                    :length="pages"
                    :total-visible="10"
                    circle
                  ></v-pagination>
                </v-card>
              </v-card-text>
             <v-card-text>
               <v-layout v-for="(question, index) in questionnaire.list" :key="index" cols="12">
                  <v-layout row wrap v-if="question.page == page">                
                    
                   
                    <v-flex xs12 v-if="question._content.description.length > 0">
                       <br/>
                      <p v-if="question.q_type == 1"><b>{{question._content.description}}</b></p>                     
                      <p v-else>{{question.number}}. {{question._content.description}}</p>                                        
                    </v-flex>

                    <v-flex xs12 v-if="question.q_type == 2 || question.q_type == 4" class="ml-answers">
                      <v-radio-group v-model="question._answer" :mandatory="false" :readonly="questionnaire.q_status != 'started'">
                        <div v-for="(item, index2) in question._choices" :key="index2" >
                          <v-radio class="mb5" :label="item" :value="index2" @click.native="saveData(index)"></v-radio>
                        </div>

                        <div class="vertically-horizontally-centered" v-if="question.q_type == 4">                    
                          <v-radio class="mb5" label="" @click.native="saveData(index)"></v-radio>
                          <v-text-field class="float-left" @blur="saveData(index)"
                          :label="question._content.other_descr"
                          :readonly="questionnaire.q_status != 'started'"
                          v-model="question._answer_descr"> 
                      </v-text-field>
                        </div>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs12 v-if="question.q_type == 3 || question.q_type == 5" class="ml-answers">
                        <div v-for="(item, index2) in question._choices" :key="index2" >
                          <v-checkbox class="v-checkbox--hidden-v-messages" v-model="question._answers[index2]" :value="1" 
                        :label="item" @click.native="saveData(index)"
                        :readonly="questionnaire.q_status != 'started'"
                      ></v-checkbox>
                        </div>

                        <div class="vertically-horizontally-centered" v-if="question.q_type == 5">
                          <v-checkbox dense v-model="question._answers[question._choices.length]" :value="1" 
                            :label="question.content.other_descr" @click.native="saveData(index)"
                            :readonly="questionnaire.q_status != 'started'">
                          </v-checkbox>
                          <v-text-field class="float-left"  
                             @blur="saveData(index)"    
                             :readonly="questionnaire.q_status != 'started'"
                             :label="question._content.other_descr"
                             v-model="question._answer_descr">
                      </v-text-field>
                        </div>
                         <br/>
                    </v-flex>

                    <v-flex xs12 v-if="question.q_type == 6">
                    <v-textarea @blur="saveData(index)" :readonly="questionnaire.q_status != 'started'"
                      v-model="question._answer"
                      filled flat outlined :rows="5"> 
                    </v-textarea>
                    </v-flex>
                    
                    <v-flex xs12 v-if="question.q_type == 7 || question.q_type == 8" style="margin-bottom:30px">
                      <v-layout row wrap class="vertically-horizontally-centered">                  
                        <v-flex xs12 class="ml-answers">
                            <div class="inline-blocks-centered-vertically p20">{{question._content.desc_first}}</div>
                            <div class="inline-blocks-centered-vertically">
                              <v-radio-group row v-model="question._answer" :mandatory="false" :readonly="questionnaire.q_status != 'started'" class="v-radio-group--hidden-v-messages">
                              <div v-for="(item, index2) in question._choices" :key="index2" >
                                <v-radio :label="item" :value="index2" @click.native="saveData(index)"></v-radio>
                              </div>
                            </v-radio-group></div>
                            <div class="inline-blocks-centered-vertically p20">{{question._content.desc_last}}</div>
                            <p></p>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
               </v-layout>
             </v-card-text>
             <v-card-text v-if = "page == pages && questionnaire.q_status == 'started'">
               <v-layout justify-center>
                <v-btn class="btn-style btn-primary" @click="submitQ()">Submit</v-btn>
               </v-layout>
             </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data() {
      return {
        questionnaire: null,
        questionaire_id: 0,
        pages: 1,
        page: 1,
        my_count : 0
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'My questionaires', href: '/myquestionnaires'},
                                           {text: 'Active questionaire', href: '/myquestionnaire/' + this.$route.params.id}])//#
      this.questionaire_id = parseInt(this.$route.params.id)
      this.getQuestionaire()
    },
    getQuestionaire() {
        axios.get('/get-my-questionaire/'+this.$route.params.id, this.$store.getters.getAxiosConfig)
          .then(res => {
            /* eslint-disable no-console */
            this.questionnaire = res.data
            for(let i = 0; i<this.questionnaire.list.length; i++) {
               if (this.questionnaire.list[i].page > this.pages) this.pages = this.questionnaire.list[i].page
               this.questionnaire.list[i]._content = JSON.parse(this.questionnaire.list[i].content)
               this.questionnaire.list[i]._choices = []
               console.log(this.questionnaire.list[i])
               if (this.questionnaire.list[i].answer==null || this.questionnaire.list[i].answer.length < 1) {
                  console.log('som tu')
                  console.log(this.questionnaire.list[i])
                  this.questionnaire.list[i]._answer = ''
                  this.questionnaire.list[i]._answers = []
                  this.questionnaire.list[i]._answer_descr = ''
               } else {
                  console.log('nie som tu')
                 const x = JSON.parse(this.questionnaire.list[i].answer)
                 console.log(x)
                 this.questionnaire.list[i]._answer = x.answer
                 this.questionnaire.list[i]._answers = x.answers
                 this.questionnaire.list[i]._answer_descr = x.answer_descr
               }               
               if (this.questionnaire.list[i].q_type == 2 || this.questionnaire.list[i].q_type == 3 || this.questionnaire.list[i].q_type == 4 || this.questionnaire.list[i].q_type == 5) {
                 this.addChoices(i, this.questionnaire.list[i]._content.choices, this.questionnaire.list[i].answer.length)                 
               }
               if (this.questionnaire.list[i].q_type == 7)  this.questionnaire.list[i]._choices.push("1","2","3","4","5")
               if (this.questionnaire.list[i].q_type == 8)  this.questionnaire.list[i]._choices.push("1","2","3","4","5","6","7")               
            }
            this.makeNumbers()
            console.log(this.questionnaire)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)          
          })
    },
    addChoices(index,data, answer_length) {      
      const list = data.split("\n");
      
      for(let i = 0; i < list.length; i++) {
        this.questionnaire.list[index]._choices.push(list[i])
        if (answer_length != 0) this.questionnaire.list[index]._answers.push(0)
      }
      if ((answer_length != 0) && (this.questionnaire.list[index].q_type == 4 || this.questionnaire.list[index].q_type == 6)) {
        this.questionnaire.list[index]._answers.push(0)
      }
    },
    saveData(index) {
      const data = {
        answer : this.questionnaire.list[index]._answer,
        answers : this.questionnaire.list[index]._answers,
        answer_descr: this.questionnaire.list[index]._answer_descr
      }
      const str = {
        u_id: this.questionnaire.uid,
        q_id: this.questionnaire.list[index].id,
        answer: JSON.stringify(data)
      }
      axios.post('/save-my-qanswer', str, this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.message == 'Error') {
              this.$store.commit('setFeedback', res.data.description) 
            }
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)          
          })
    },
    submitQ() {
      const str = {
        u_id: this.questionnaire.uid,        
      }
      axios.post('/submit-questionnaire', str, this.$store.getters.getAxiosConfig)
          .then((res) => {
            if (res.data.message == 'Error') {
              this.$store.commit('setFeedback', res.data.description) 
            }
            if (res.data.message == 'OK') {
              this.$store.commit('setUserPerformance',res.data.user) 
              this.questionnaire.q_status = 'finished'
            }
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)          
          })
    },          
    makeNumbers() {
      for(let page = 1; page <= this.pages; page++) {
        var _p = 1
        for(let i = 0; i<this.questionnaire.list.length; i++ ) {
          if (this.questionnaire.list[i].page == page && this.questionnaire.list[i].q_type > 1) {
             this.questionnaire.list[i].number = _p
            _p = _p + 1
          }
        }
      }
    }
   }
  }
</script>

<style>

</style>